import { useEffect, useState } from "react";
import api from "@/lib/api";
import { statusColor, daysLabel } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const CARDS = [
  { key: "all", label: "Total", filter: () => true, color: "bg-slate-100 text-slate-700" },
  { key: "active", label: "Active", filter: (r) => r.status === "active", color: "bg-emerald-100 text-emerald-700" },
  { key: "expiring", label: "Expiring Soon", filter: (r) => r.status === "expiring", color: "bg-amber-100 text-amber-700" },
  { key: "expired", label: "Expired", filter: (r) => r.status === "expired", color: "bg-rose-100 text-rose-700" },
];

export default function Subscriptions() {
  const [rows, setRows] = useState([]);
  const [active, setActive] = useState("all");

  useEffect(() => { api.get("/admin/sellers?sort=expiry").then(({ data }) => setRows(data.filter((r) => r.package_id))); }, []);

  const filtered = rows.filter(CARDS.find((c) => c.key === active).filter);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-extrabold">Subscriptions</h1>
        <p className="text-muted-foreground text-sm font-medium">All yearly subscribers and their package tiers.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map((c) => {
          const count = rows.filter(c.filter).length;
          return (
            <button key={c.key} data-testid={`sub-card-${c.key}`} onClick={() => setActive(c.key)}
              className={`text-left border-2 rounded-xl p-4 transition-all ${active === c.key ? "border-primary ring-2 ring-primary/20" : "border-transparent bg-card"}`}>
              <div className={`inline-block text-xs font-bold px-2 py-0.5 rounded ${c.color}`}>{c.label}</div>
              <div className="font-heading text-2xl font-extrabold mt-2">{count}</div>
            </button>
          );
        })}
      </div>

      <div className="bg-card border rounded-xl overflow-x-auto ct-scroll">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Company</TableHead><TableHead>Type</TableHead><TableHead>Package</TableHead>
            <TableHead>Start</TableHead><TableHead>Expiry</TableHead><TableHead>Status</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {filtered.map((r) => (
              <TableRow key={r.id} data-testid={`sub-row-${r.id}`}>
                <TableCell className="font-semibold">{r.company_name}</TableCell>
                <TableCell className="capitalize">{r.role}</TableCell>
                <TableCell className="font-semibold">{r.package_label || "—"}</TableCell>
                <TableCell className="text-xs">{r.start ? new Date(r.start).toLocaleDateString("en-IN") : "—"}</TableCell>
                <TableCell className="text-xs">{r.expiry ? new Date(r.expiry).toLocaleDateString("en-IN") : "—"} <span className="text-muted-foreground">({daysLabel(r.days_remaining)})</span></TableCell>
                <TableCell><Badge className={`border ${statusColor(r.status)}`}>{r.status}</Badge></TableCell>
              </TableRow>
            ))}
            {filtered.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground font-semibold">No subscribers.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
